import axios from "axios";

const ENQUIRIES_URL = "https://meghaengg.ac.in/api/enquiries";

export async function submitInquiry(payload) {
  const res = await axios.post(ENQUIRIES_URL, {
    name: payload.name,
    phone: payload.phone,
    course: payload.course,
    message: payload.message || "",
    ...(payload.email && { email: payload.email }),
  }, {
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });
  return res.data;
}
